import { render, staticRenderFns } from "./DomainIpList.vue?vue&type=template&id=b64415f4&scoped=true"
import script from "./DomainIpList.vue?vue&type=script&lang=js"
export * from "./DomainIpList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64415f4",
  null
  
)

export default component.exports